@reference "@glow/tailwind-config/reference.css";

.status {
  @apply rounded-sm;
  @apply font-semibold;
  @apply border;
  @apply border-transparent;
  @apply px-2;
  @apply flex;
  @apply flex-col;
  @apply justify-center;
  @apply whitespace-nowrap;
  @apply w-fit;
}

.status.large {
  @apply min-h-8;
  @apply text-sm;
}

.status.small {
  @apply min-h-6;
  @apply text-xs;
}

.status.hasBorder {
  @apply border;
  @apply border-solid;
  @apply border-current;
}

.status svg:first-of-type {
  @apply inline-block;
}

.status.noIcon .content {
  @apply grid-cols-[auto];
}

.status.neutral {
  @apply bg-gray-200;
}

.status.success {
  @apply bg-success-light;
  @apply text-success-dark;
}

.status.danger {
  @apply bg-danger-light;
  @apply text-danger-dark;
}

.status.warning {
  @apply bg-warning-light;
  @apply text-warning-dark;
}

.status.in-progress {
  @apply bg-sky-50;
  @apply text-sky-800;
}
